module.exports = __webpack_public_path__ + "img/pr-3.22b3084c.png";